export const partIVQuestions = [
    { id: 93, text: "Challenging myself to achieve", n: 1 },
    { id: 94, text: "Being liked by others", n: 2 },
    { id: 96, text: "Being sensitive to others’ needs", n: 3 },
    { id: 95, text: "Protecting the environment", n: 4 },
    { id: 111, text: "Creating new things or ideas", n: 5 },
    { id: 108, text: "Being accepted by others", n: 6 },
    { id: 109, text: "Taking care of the environment", n: 7 },
    { id: 107, text: "Improving my performance", n: 8 },
    { id: 110, text: "Helping others", n: 9 },
    { id: 106, text: "Believing in a higher power", n: 10 },
    { id: 121, text: "Working hard to do better", n: 11 },
    { id: 113, text: "Being in good physical shape", n: 12 },
    { id: 112, text: "Making money", n: 13 },
    { id: 123, text: "Appreciating the beauty of nature", n: 14 },
    { id: 129, text: "Having control over my time", n: 15 },
    { id: 131, text: "Having a private place to go", n: 16 },
    { id: 122, text: "Feeling as though I belong", n: 17 },
    { id: 132, text: "Meeting my obligations", n: 18 },
    { id: 116, text: "Respecting the traditions of my family or group", n: 19 },
    { id: 130, text: "Making decisions with my family or group in mind", n: 20 },
    { id: 133, text: "Knowing about math", n: 21 },
    { id: 134, text: "Living in harmony with my spiritual beliefs", n: 22 },
    { id: 128, text: "Avoid credit for my accomplishments", n: 23 },
    { id: 124, text: "Being concerned about the rights of others", n: 24 },
    { id: 99, text: "Taking care of my body", n: 25 },
    { id: 117, text: "Having quiet time to think", n: 26 },
    { id: 127, text: "Being strong or good in a sport (being athletic)", n: 27 },
    { id: 126, text: "Being wealthy (having lots of money, land or livestock)", n: 28 },
    { id: 119, text: "Knowing things about science", n: 29 },
    { id: 118, text: "Being trustworthy", n: 30 },
    { id: 120, text: "Believing that there is something greater than ourselves", n: 31 },
    { id: 114, text: "Being quiet about my success", n: 32 },
    { id: 125, text: "Discovering new things or ideas", n: 33 },
    { id: 105, text: "Using science for progress", n: 34 },
    { id: 102, text: "Accepting my place in my family or group", n: 35 },
    { id: 104, text: "Being reliable", n: 36 },
    { id: 115, text: "Giving my opinion", n: 37 },
    { id: 98, text: "Having financial success", n: 38 },
    { id: 101, text: "Being independent (doing things I want to do)", n: 39 },
    { id: 103, text: "Having time to myself", n: 40 },
    { id: 100, text: "Downplaying compliments or praise", n: 41 },
    { id: 97, text: "Coming up with new ideas", n: 42 }
  ];